import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { useIntl } from 'react-intl';
import { isMini } from '../../helpers/App';

const UploadModalTabs = ({
  activeTab,
  handleSwitchTab,
}) => {
  const intl = useIntl();

  return (
    <Nav tabs className={classnames('settings-tabs icon-tabs', { 'icon-tabs-mini': isMini() })}>
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === 'details' })}
          onClick={() => { handleSwitchTab('details'); }}
        >
          <i className="fa-solid fa-memo" />
          <span>{intl.formatMessage({ defaultMessage: 'Details' })}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === 'advanced' })}
          onClick={() => { handleSwitchTab('advanced'); }}
        >
          <i className="fa-solid fa-list-check" />
          <span>{intl.formatMessage({ defaultMessage: 'Advanced' })}</span>
        </NavLink>
      </NavItem>
    </Nav>
  );
};

UploadModalTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  handleSwitchTab: PropTypes.func.isRequired,
};

export default UploadModalTabs;
